export var ExperimentConfig = {
    RBExperimentProduction: {
        flagKey: 'rb-experiment-production',
        variants: ['control', 'treatment'],
    },
    // DEAP-3695: gates the top "Other designs you might like" (offsite) swimlane on
    // the PDP. Defaults to off (no enrolment) so the swimlane is hidden for everyone;
    // the `control` variant re-shows it (the intact above-the-fold experience).
    OffsiteSimilarDesigns: {
        flagKey: 'rb-offsite-similar-designs-pdp',
        variants: ['control', 'treatment'],
    },
    CartTrayExpressPayments: {
        flagKey: 'rb-cart-tray-express-payments',
        variants: ['control', 'variant'],
    },
    CheckoutHeader: {
        flagKey: 'rb-checkout-header-simplified',
        variants: ['control', 'treatment'],
    },
    CheckoutExpressPaymentsPrioritization: {
        flagKey: 'rb-checkout-express-payments-prioritization',
        variants: ['control', 'treatment'],
    },
    CartTrayCTA: {
        flagKey: 'rb-cart-tray-cta',
        variants: ['control', 'treatment'],
    },
    CartShippingRemoval: {
        flagKey: 'rb-cart-shipping-removal',
        variants: ['control', 'treatment'],
    },
    NavTopicsInternal: {
        flagKey: 'rb-nav-topics-internal',
        variants: ['control', 'treatment'],
    },
    SrpStandardPricing: {
        flagKey: 'rb-srp-standard-pricing',
        variants: ['control', 'treatment'],
    },
    PdpMobileColorSwatchVisibility: {
        flagKey: 'rb-pdp-mobile-color-swatch-visibility',
        variants: ['control', 'treatment'],
    },
    FlatLaySRPImage: {
        flagKey: 'rb-flat-lay-srp-image',
        variants: ['control', 'treatment'],
    },
    PdpApparelLeadingImage: {
        flagKey: 'rb-pdp-apparel-leading-image',
        variants: ['control', 'treatment'],
    },
};
export var AMPLITUDE_OFF_ENROLMENT = 'off';
